import { apiGet } from '../support/helpers/ApiConnection.Helper';
import BodySideEntity from '../entities/BodySide.Entity';

export default function getBodySides(abortSignal: AbortSignal): Promise<Array<BodySideEntity>> {   
    return apiGet<Array<BodySideEntity>>('/body-sides',abortSignal);
}